module.exports = __webpack_public_path__ + "img/upload_cheque.6282f95e.jpg";